// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1braglyw._1braglyw{list-style-type:none}\n._1yxxidpf._1yxxidpf{padding-left:0}", ""]);
// Exports
module.exports = exports;
